const QualifiedShareDividends = {
  K10Form: "QualifiedShareDividends.K10Form",
  State_0: "QualifiedShareDividends.State_0",
  State_2: "QualifiedShareDividends.State_2",
  State_4: "QualifiedShareDividends.State_4",
  IncomeYear: "QualifiedShareDividends.IncomeYear",
  IncomeYear2: "QualifiedShareDividends.IncomeYear2",
  Rule: "QualifiedShareDividends.Rule",
  DividendReceived: "QualifiedShareDividends.DividendReceived",
  DividendsToBeRaisedInCapital: "QualifiedShareDividends.DividendsToBeRaisedInCapital",
  Rule_0: "QualifiedShareDividends.Rule_0",
  Rule_1: "QualifiedShareDividends.Rule_1",
  DividendsToBeTaxedOnService: "QualifiedShareDividends.DividendsToBeTaxedOnService",
  SavedDividendSpace: "QualifiedShareDividends.SavedDividendSpace",
  SelectionHeaderTextToApprove: "QualifiedShareDividends.SelectionHeaderTextToApprove",
  QualifiedShareDividendsAcceptSuccessMessage: "QualifiedShareDividends.QualifiedShareDividendsAcceptSuccessMessage",
  QualifiedShareDividendRejectSuccessMessage: "QualifiedShareDividends.QualifiedShareDividendRejectSuccessMessage",
  ReviewDeclaration: "QualifiedShareDividends.ReviewDeclaration",
  InformationForQualifiedSharedDividend: "QualifiedShareDividends.InformationForQualifiedSharedDividend",
  Received: "QualifiedShareDividends.Received",
  ReportDescription: "QualifiedShareDividends.ReportDescription",
  Dividend: "QualifiedShareDividends.Dividend",
  SelectionHeaderText: "QualifiedShareDividends.SelectionHeaderText",
  SelectionSubText: "QualifiedShareDividends.SelectionSubText",
  ToApproveHeader: "QualifiedShareDividends.ToApproveHeader",
  ToApproveDescription: "QualifiedShareDividends.ToApproveDescription",
  FinancialYear: "QualifiedShareDividends.FinancialYear",
  Planned: "QualifiedShareDividends.Planned",
  Completed: "QualifiedShareDividends.Completed",
  ToApprove: "QualifiedShareDividends.ToApprove",
  DashboardWidgetTitle: "QualifiedShareDividends.DashboardWidgetTitle",
  DashboardWidgetDescription: "QualifiedShareDividends.DashboardWidgetDescription",
  DashboardWidgetButton: "QualifiedShareDividends.DashboardWidgetButton",
  DashboardWidgetLabel: "QualifiedShareDividends.DashboardWidgetLabel",
  }
export default QualifiedShareDividends;